import React from 'react';
import { st, classes } from './text-extended.st.css';
import cssVars from '../styles/css-vars.scss';
export const TextExtended = (props) => (React.createElement(TextExtendedNoUseApi, { ...props, mobile: props.isMobile }));
export const TextExtendedNoUseApi = ({ className, priority = 'primary', typography = 'content', dataHook, mobile, size, tag, ...props }) => {
    const Component = (tag ?? 'span');
    return (React.createElement(Component, { className: st(classes.root, { priority, typography, mobile, size: size || typography }, cssVars.reactionsContainer, className), "data-hook": dataHook, ...props }));
};
//# sourceMappingURL=text-extended.js.map